import { Button, Container, Stack, Typography, Box, TableContainer, Paper, TableHead, Table, TableRow, TableCell, Tooltip, ClickAwayListener } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import Footer from "splash_components/Splash/CommonComponents/Footer";
import { NavigationBar } from "splash_components/Splash/CommonComponents/NavigationBar";

import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import StarIcon from '@mui/icons-material/Star';

import React, { ReactNode, useState } from "react";

import { tSplash } from "locales/splash/cruxTranslation";

function makeStarMarkup(stars: number) {
  return (
    <Stack direction="row" alignItems="center">
      <b>{stars}</b>
      <StarIcon htmlColor="#FFC107" />
    </Stack>
  );

}

export default function CruxVsStokt() {
  const COMPARISON = [
    [tSplash("crux_vs_stokt.comparison.climbs_title"), [
      [tSplash("crux_vs_stokt.comparison.set_climbs_on_spray"), true, true],
      [tSplash("crux_vs_stokt.comparison.climb_circuits"), true, true],
      [tSplash("crux_vs_stokt.comparison.search_sort_climbs"), true, true],
      [tSplash("crux_vs_stokt.comparison.comment_on_climbs"), true, true],
      [tSplash("crux_vs_stokt.comparison.adjustable_angle_walls"), true, true, tSplash("crux_vs_stokt.comparison.adjustable_angle_walls_tooltip")],
      [tSplash("crux_vs_stokt.comparison.set_climbs_on_regular_walls"), true, false, tSplash("crux_vs_stokt.comparison.set_climbs_on_regular_walls_tooltip")],
      [tSplash("crux_vs_stokt.comparison.free_and_unlimited_wall_resets"), true, false, tSplash("crux_vs_stokt.comparison.free_and_unlimited_wall_resets_tooltip")],
      [tSplash("crux_vs_stokt.comparison.post_beta_videos_on_climbs"), true, false, tSplash("crux_vs_stokt.comparison.post_beta_videos_on_climbs_tooltip")],
    ]],
    [tSplash("crux_vs_stokt.comparison.gym_management_title"), [
      [tSplash("crux_vs_stokt.comparison.full_administrator_control"), true, true],
      [tSplash("crux_vs_stokt.comparison.multiple_walls_and_areas"), true, true, tSplash("crux_vs_stokt.comparison.multiple_walls_and_areas_tooltip")],
      [tSplash("crux_vs_stokt.comparison.custom_lists"), true, true, tSplash("crux_vs_stokt.comparison.custom_lists_tooltip")],
      [tSplash("crux_vs_stokt.comparison.broadcast_announcements"), true, false, tSplash("crux_vs_stokt.comparison.broadcast_announcements_tooltip")],
      [tSplash("crux_vs_stokt.comparison.instant_wall_resets"), true, false, tSplash("crux_vs_stokt.comparison.instant_wall_resets_tooltip")],
    ]],
    [tSplash("crux_vs_stokt.comparison.climber_experience_title"), [
      [tSplash("crux_vs_stokt.comparison.track_sends_and_attempts"), true, true],
      [tSplash("crux_vs_stokt.comparison.climber_stats_metrics_graphs"), true, true, tSplash("crux_vs_stokt.comparison.climber_stats_metrics_graphs_tooltip")],
      [tSplash("crux_vs_stokt.comparison.browse_climber_sessions"), true, false],
      [tSplash("crux_vs_stokt.comparison.profile_privacy_settings"), true, false, tSplash("crux_vs_stokt.comparison.profile_privacy_settings_tooltip")],
    ]],
    [tSplash("crux_vs_stokt.comparison.miscellaneous_title"), [
      [tSplash("crux_vs_stokt.comparison.free_for_climbers"), true, true],
      [tSplash("crux_vs_stokt.comparison.climber_leaderboards"), true, true],
      [tSplash("crux_vs_stokt.comparison.setter_leaderboards"), true, false],
      [tSplash("crux_vs_stokt.comparison.per_gym_climber_forum"), true, false, tSplash("crux_vs_stokt.comparison.per_gym_climber_forum_tooltip")],
      [tSplash("crux_vs_stokt.comparison.competitions"), false, true, tSplash("crux_vs_stokt.comparison.competitions_tooltip")],
    ]]
  ] as [string, [title: string, supported_on_crux: (boolean | ReactNode), supported_on_stokt: (boolean | ReactNode), tooltip?: ReactNode][]][]
  // Not sure why, but typescript was having issues understanding the structure of this. Spelling it out helps fix some TS errors.


  const [currentOpenFeature, setCurrentOpenFeature] = useState<string>(null)

  const theme = useTheme();


  return (
    <div style={{ backgroundColor: "#F4F4F1", userSelect: "text" }}>
      {screen.width < theme.breakpoints.values.sm ? (
        // Mobile
        <>
          <NavigationBar theme={theme} mobile />
          <Container
            style={{
              paddingLeft: theme.spacing(6),
              paddingRight: theme.spacing(6),
              paddingTop: theme.spacing(5),
            }}
          >
            <Stack
              direction="column"
              alignItems="center"
              justifyContent="center"
              spacing={2}
            >
              <Stack
                direction="column"
                alignItems="center"
                justifyContent="center"
                spacing={4}
                sx={{ width: "100%" }}
              >
                <img src="https://imagedelivery.net/6AOsI3ukInId8El8sSekmQ/c38fb3dc-423c-4bca-3738-80440dce3c00/largeavatar" style={{ height: "75px" }} alt="Crux Logo" />
                <Typography variant="h4" sx={{ textAlign: "center" }}>
                  <b>
                    {tSplash("crux_vs_stokt.title")}
                  </b>
                </Typography>
              </Stack>
              <Typography variant="subtitle1" sx={{ textAlign: "center" }}>
                {tSplash("crux_vs_stokt.subtitle")}
              </Typography>
            </Stack>
          </Container>
          <Stack alignItems="center" justifyContent="center" width="100%" mt={2} pb={6}>
            <TableContainer
              component={Paper}
              sx={{
                width: "90vw"
              }}
            >
              <Table>
                <TableHead>
                  <TableRow>
                    {/* This first table cell should take up 75% of the width */}
                    <TableCell
                      sx={{
                        width: "75%"
                      }}
                    >
                    </TableCell>
                    <TableCell align="left" sx={{ verticalAlign: "bottom" }}>
                      <Stack direction="column" alignItems="center" justifyContent="flex-end" spacing={1}>
                        <img src="https://imagedelivery.net/6AOsI3ukInId8El8sSekmQ/c38fb3dc-423c-4bca-3738-80440dce3c00/largeavatar" style={{ height: "28px" }} alt="Crux Logo" />
                        <span>Crux</span>
                      </Stack>
                    </TableCell>
                    <TableCell align="left" sx={{ verticalAlign: "bottom" }}>
                      <Stack direction="column" justifyContent="flex-end">Stōkt</Stack></TableCell>
                  </TableRow>
                </TableHead>
                {/* A full-length (colspan 3) row with the section header, then a row per feature */}
                <>
                  {COMPARISON.map((section) => {
                    return (
                      <>
                        <TableRow>
                          <TableCell colSpan={3} sx={{ fontWeight: 700, paddingTop: "22px", paddingBottom: "18px", textTransform: "uppercase", backgroundColor: "#0e3872", color: "white" }}>
                            {section[0]}
                          </TableCell>
                        </TableRow>
                        {section[1].map((feature, i) => {
                          return (
                            <TableRow
                              sx={{
                                backgroundColor: i % 2 === 1 ? "#f2f2f2" : "white",
                              }}
                            >
                              <TableCell >
                                <Stack direction="row" alignItems="center">
                                  <span>
                                    {feature[0]}
                                  </span>
                                  <Box flexGrow={1} />
                                  {feature[3] && <ClickAwayListener touchEvent="onTouchStart" onClickAway={() => { if (currentOpenFeature === feature[0]) setCurrentOpenFeature(null) }}>
                                    <Tooltip title={<Typography variant="body2" sx={{ lineHeight: 2 }}>{feature[3]}</Typography>} open={currentOpenFeature === feature[0]} PopperProps={{
                                      disablePortal: true, sx: {
                                        // Apply bg to first child
                                        "& .MuiTooltip-tooltip": {
                                          backgroundColor: "#666666f2",
                                        },
                                      }
                                    }} onClick={() => {
                                      if (currentOpenFeature === feature[0]) {
                                        setCurrentOpenFeature(null)
                                      } else {
                                        setCurrentOpenFeature(feature[0])
                                      }
                                    }}>
                                      <HelpOutlineIcon fontSize="small" color="action" sx={{
                                        cursor: "pointer",
                                        marginLeft: "6px",
                                      }}
                                      />
                                    </Tooltip>
                                  </ClickAwayListener>}
                                </Stack>
                              </TableCell>
                              <TableCell>
                                {/* If this is a Node, render the Node, otherwise render the CheckCircleIcon if it's true */}
                                {/* {feature[1] && <CheckCircleIcon htmlColor="green" />} */}

                                {typeof feature[1] === "boolean" && feature[1] && <CheckCircleIcon htmlColor="green" />}
                                {typeof feature[1] === "object" && feature[1]}
                              </TableCell>
                              <TableCell>
                                {typeof feature[2] === "boolean" && feature[2] && <CheckCircleIcon htmlColor="green" />}
                                {typeof feature[2] === "object" && feature[2]}
                              </TableCell>
                            </TableRow >
                          )
                        })}
                      </>
                    )
                  })}
                </>
              </Table>
            </TableContainer>
          </Stack>
          <Footer theme={theme} />
        </>
      ) : (
        // Desktop
        <>
          <Container
            style={{
              paddingLeft: theme.spacing(6),
              paddingRight: theme.spacing(6),
            }}
          >
            <NavigationBar theme={theme} mobile={false} />
            <Box pt={theme.spacing(12)} pb={theme.spacing(3)}>
              <Stack
                direction="column"
                alignItems="center"
                justifyContent="center"
                spacing={4}
              >
                <Stack direction="row" justifyContent="center" alignItems="center">
                  <img src="https://imagedelivery.net/6AOsI3ukInId8El8sSekmQ/c38fb3dc-423c-4bca-3738-80440dce3c00/largeavatar" style={{ height: "100px" }} alt="Crux Logo" />
                </Stack>

                <Stack
                  direction="column"
                  alignItems="center"
                  justifyContent="center"
                >
                  <Typography variant="h2" sx={{ textAlign: "center", fontWeight: 900, maxWidth: "800px" }}>
                    {tSplash("crux_vs_stokt.title")}
                  </Typography>
                  <Typography
                    variant="h6"
                    sx={{ textAlign: "center", marginTop: theme.spacing(1), maxWidth: "80%", fontWeight: 400 }}
                  >
                    {tSplash("crux_vs_stokt.subtitle")}
                  </Typography>
                </Stack>
              </Stack>
            </Box>
          </Container>
          <Container
            sx={{
              pl: 6,
              pr: 6,
              pt: 4,
              pb: 4
            }}
          >
            <Stack alignItems="center" justifyContent="center" width="100%">
              <TableContainer
                component={Paper}
                sx={{
                  maxWidth: 800
                }}
              >
                <Table>
                  <TableHead>
                    <TableRow>
                      {/* This first table cell should take up 75% of the width */}
                      <TableCell
                        sx={{
                          width: "75%"
                        }}
                      >
                      </TableCell>
                      <TableCell align="left">
                        <Stack direction="row" alignItems="center" justifyContent="flex-start" spacing={1}>
                          <img src="https://imagedelivery.net/6AOsI3ukInId8El8sSekmQ/c38fb3dc-423c-4bca-3738-80440dce3c00/largeavatar" style={{ height: "28px" }} alt="Crux Logo" />
                          <span>Crux</span>
                        </Stack>
                      </TableCell>
                      <TableCell align="left">Stōkt</TableCell>
                    </TableRow>
                  </TableHead>
                  {/* A full-length (colspan 3) row with the section header, then a row per feature */}
                  {COMPARISON.map((section) => {
                    return (
                      <>
                        <TableRow>
                          <TableCell colSpan={3} sx={{ fontWeight: 700, paddingTop: "22px", paddingBottom: "18px", textTransform: "uppercase", backgroundColor: "#0e3872", color: "white" }}>
                            {section[0]}
                          </TableCell>
                        </TableRow>
                        {section[1].map((feature, i) => {
                          return (
                            <TableRow
                              sx={{
                                backgroundColor: i % 2 === 1 ? "#f2f2f2" : "white",
                              }}
                            >
                              <TableCell>
                                <Stack direction="row" alignItems="center">
                                  <span>
                                    {feature[0]}
                                  </span>
                                  <Box flexGrow={1} />
                                  {feature[3] && <Tooltip title={<Typography variant="body2" sx={{ lineHeight: 2 }}>{feature[3]}</Typography>} PopperProps={{
                                    sx: {
                                      lineHeight: 2,
                                      // Apply bg to first child
                                      "& .MuiTooltip-tooltip": {
                                        backgroundColor: "#666666f2",
                                      },
                                    }
                                  }}>
                                    <HelpOutlineIcon fontSize="small" color="action" sx={{
                                      cursor: "pointer",
                                      marginLeft: "6px",
                                    }} />
                                  </Tooltip>}
                                </Stack>
                              </TableCell>
                              <TableCell>
                                {/* If this is a Node, render the Node, otherwise render the CheckCircleIcon if it's true */}
                                {/* {feature[1] && <CheckCircleIcon htmlColor="green" />} */}

                                {typeof feature[1] === "boolean" && feature[1] && <CheckCircleIcon htmlColor="green" />}
                                {typeof feature[1] === "object" && feature[1]}
                              </TableCell>
                              <TableCell>
                                {typeof feature[2] === "boolean" && feature[2] && <CheckCircleIcon htmlColor="green" />}
                                {typeof feature[2] === "object" && feature[2]}
                              </TableCell>
                            </TableRow>
                          )
                        })}
                      </>
                    )
                  })}
                </Table>
              </TableContainer>
            </Stack>
          </Container>
          <Footer theme={theme} />
        </>
      )
      }
    </div >
  );
}
